import React from "react";
import { Users, Leaf, ShieldCheck } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const impactData = [{
  title: "Local Orlando Expertise",
  description: "Deep roots in Central Florida's market ensure your property is positioned for maximum growth and visibility.",
  stat: "15+ Years",
  icon: Users
}, {
  title: "Data-Backed Accuracy",
  description: "Our proprietary analysis tools provide precise rental valuations and comprehensive market trend insights.",
  stat: "98% Accuracy",
  icon: ShieldCheck
}, {
  title: "Zero-Obligation Consultation",
  description: "Transparent advice without the pressure, helping you make informed decisions for your real estate portfolio.",
  stat: "Free Strategy",
  icon: Leaf
}];
export default function ImpactSocial() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}